import YoutubeHeroPlayer from './youtube';
import VimeoHeroPlayer from './vimeo';

/**
 * The following video player wrappers are intended for video heros that require user
 * interaction to begin. The components are subclasses of a base `HeroPlayer` class
 * that manages:
 *
 *  - Rendering a play button, and the fade transition upon clicking to begin playback.
 *  - Rendering a video image "poster"
 *  - Fading in the iframe video.
 */
document.addEventListener("DOMContentLoaded", () => {
  window.onYouTubeIframeAPIReady = () => {
    if (document.querySelector('[data-youtube-id]')) {
      new YoutubeHeroPlayer();
    }
  };

  if (document.querySelector('[data-vimeo-id]')) {
    new VimeoHeroPlayer();
  }
});
